<template>
    <div class="text-center">
      <v-dialog
          :value="show && !stepUpActive"
          hide-overlay
          persistent
          width="300"
      >
      <v-card class="pa-4 text-center rounded-lg">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
          <div class="text-body-2 mt-4">Processing...</div>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  
  
  <script>
  import stepUpPrompt from "@/shared/stepUpPrompt";

  export default {
    name: "LoadingDialogV2",
    props: {
      show: Boolean,
      message: String,
    },
    computed: {
      // The step-up (OTP) dialog needs user input. If a "Processing..." overlay is
      // showing when step-up opens, it covers the code field -> "loading forever".
      // Suppress this loader whenever the global step-up prompt is visible.
      stepUpActive() {
        return stepUpPrompt.state.show;
      }
    }
  }
  </script>
  
  <style scoped>
  .v-card {
    transition: all 0.2s ease;
  }
  
  .v-card:hover {
    transform: translateY(-2px);
  }
  
  .text-center .v-icon {
    opacity: 0.5;
  }
  
  .v-select.rounded-lg >>> .v-input__slot {
    border-radius: 8px !important;
  }
  
  .v-progress-circular {
    font-weight: 600;
    font-size: 0.875rem;
  }
  
  @keyframes pulse {
    0% {
      transform: scale(0.95);
      opacity: 0.8;
    }
    50% {
      transform: scale(1);
      opacity: 1;
    }
    100% {
      transform: scale(0.95);
      opacity: 0.8;
    }
  }
  
  .loading-animation {
    animation: pulse 1.5s ease-in-out infinite;
  }
  
  /* Responsive adjustments */
  @media (max-width: 600px) {
    .container.pa-6 {
      padding: 16px !important;
    }
    
    .v-card-title {
      font-size: 1.25rem !important;
    }
    
    .text-h4 {
      font-size: 1.5rem !important;
    }
    
    .v-btn-toggle {
      margin-top: 12px;
      width: 100%;
    }
  }
  </style>
  